import { RenderAnimationProps, Router } from "easy-page-router/react";

import Index from "./pages/Index";
import Pages from "./pages/Pages";
import Mayors from "./pages/Mayors";
import Contact from "./pages/Contact";
import Evenings from "./pages/Evenings";
import NotFound from "./pages/NotFound";
import Education from "./pages/Education";
import Downloads from "./pages/Downloads";
import Reservation from "./pages/Reservation";
import Application from "./pages/Application";
import { useEffect, useState } from "react";

export default function JSORouter() {
    return <div className="router">
        <Router
            renderAnimation={Animation}
            renderPage={({ path }) => {
                if (path[0] === "pl")
                    path = path.slice(1);

                if (path.length === 0) return <Index />;

                if (path[0] === "o-nas") return <Pages
                    type="about-us"
                    url={path[1] || "historie"}
                />;
                if (path[0] === "turista") return <Pages
                    type="tourist"
                    url={path[1] || "o-mikroregionu"}
                />;


                if (path[0] === "uredni-deska") return <Downloads
                    title="Úřední deska"
                    folder="board"
                    background="deska"
                />;
                if (path[0] === "verejne-dokumenty") return <Downloads
                    title="Veřejné dokumenty"
                    folder="documents"
                    background="dokumenty"
                />;

                if (path[0] === "vzdelavani" || path[0] === "vzdelani") return <Education />;
                if (path[0] === "kurz" && path[1]) return <Application id={path[1]} />

                if (path[0] === "krakonosovy-letni-podvecery") return <Evenings />;
                if (path[0] === "rezervace-jarmarecniho-stanku") return <Reservation />;

                if (path[0] === "kontakty") return <Contact />;

                if (path[0] === "starosta") return <Mayors />;

                return <NotFound />;
            }}
        />
    </div>;
}

function Animation({ page, state }: RenderAnimationProps) {
    const [newClass, setNewClass] = useState("new");
    const [hide, setHide] = useState(false);

    useEffect(() => {
        if (state === "active") {
            setHide(false);
        } else {
            setNewClass("");
            setTimeout(() => setHide(true), 500);
        }
    }, [state]);

    return <div className={`router-page ${state} ${newClass} ${hide ? "hidden" : ""}`}>{page}</div>;
}
